import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { RectangleGroupIcon, UserGroupIcon } from '@heroicons/react/24/solid'
import { Link } from 'react-router-dom'
import AppShell from '../../Components/AppShell'
import PageHeader from '../../Components/PageHeader'

const AdminPage = () => {
  const [users, setUsers] = useState([])
  const [departments, setDepartments] = useState([])

  const deptsCount = departments.length
  const activeUsersCount = users.filter((user) => user.isActive).length

  useEffect(() => {
    Promise.all([
      axios.get('/api/users/get-users?role=&isActive='),
      axios.get('/api/departments/get'),
    ])
      .then(([usersResponse, departmentsResponse]) => {
        if (usersResponse.data.message) {
          console.log('Cannot get users')
        } else {
          setUsers(usersResponse.data.result)
        }

        if (departmentsResponse.data.message) {
          console.log('Cannot get departments')
        } else {
          setDepartments(departmentsResponse.data.result)
        }
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }, [])

  return (
    <AppShell>
      <PageHeader
        kicker="Admin"
        title="Dashboard"
        subtitle="Monitor active users and department inventory."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Admin' },
        ]}
      />

      <div className="grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2">
        <Link to="/adminNXS0011/manage-users" className="nx-panel group relative p-6 hover:border-signal/40">
          <p className="font-mono text-4xl text-signal">{activeUsersCount}</p>
          <p className="mt-1 text-sm text-muted">Active users</p>
          <UserGroupIcon className="absolute right-5 top-1/2 h-10 w-10 -translate-y-1/2 text-signal/20 transition group-hover:text-signal/50" />
        </Link>

        <Link
          to="/adminNXS0011/manage-departments"
          className="nx-panel group relative p-6 hover:border-amber/40"
        >
          <p className="font-mono text-4xl text-amber">{deptsCount}</p>
          <p className="mt-1 text-sm text-muted">Departments</p>
          <RectangleGroupIcon className="absolute right-5 top-1/2 h-10 w-10 -translate-y-1/2 text-amber/20 transition group-hover:text-amber/50" />
        </Link>
      </div>
    </AppShell>
  )
}

export default AdminPage
